<!-- <div style="min-height: 30px;">
    <button (click)="this.handleAction('OnBack')" class="back-button pointer" fxLayout="row" fxLayoutAlign="start center">
      <i *ngIf="parentName !== 'Orbitax Drive'" class="far fa-long-arrow-left m-r-7"></i>
      <span class="folder-name">{{parentName}}</span>
    </button>
  
</div> -->
  <div
    (scrolled)="onScroll()"
    *ngIf="iconViewResponse && iconViewResponse.items.length>0"
    [alwaysCallback]="true"
    [infiniteScrollDisabled]="infiniteScrollDisabled"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false" class="list-content"
    infiniteScroll>
    <mat-list role="list">
      <div *ngFor="let iconResponse of iconViewResponse?.items" class="list-content-wrapper">
  
        <div [ngStyle]="{'backgroundColor': (iconResponse === selectedItem)? '#337aee': ''}"
             class="list-content-container"
             fxLayout="row" fxLayoutAlign="space-between center">
          <mat-list-item (click)="this.handleAction('SelectItem', iconResponse)"
                         (dblclick)="this.handleAction('GoToItem', iconResponse)" (mousedown)="$event.preventDefault()">
            <div class="{{iconResponse.icon}}"></div>
            <span [ngStyle]="{'color': (iconResponse === selectedItem)? '#fff': ''}" class="icon-response-name m-l-18"
                  matTooltip="{{iconResponse.name}}">{{iconResponse.name}}</span>
          </mat-list-item>
          <i *ngIf="iconResponse.type != 'File'" (click)="goToItem(iconResponse)"
             [ngStyle]="(iconResponse === selectedItem)?{'color': '#fff', 'visibility': 'visible'}:{}"
             class="far fa-chevron-right"></i>
        </div>
      </div>
    </mat-list>
  </div>
  